import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import ProfessionalServicesCard from './ProfessionalServicesCard';

const ProfessionalServicesSlider = () => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrow: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          variableWidth: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
    ],
  };
  return (
    <>
      <style>
        {`
         
          .seo-services-slider .slick-track {
            display: flex;
          }
          .custom-dots {
            display:flex!important;
            justify-content:center;
          }
          .custom-dots li{
            position:relative;
            margin:0 3px;
            margin-top:20px;
            width:50px;
            height:2px;
            background-color: #C4C4C4;
            overflow:hidden;
        }
         .seo-services .custom-dots li:first-child.slick-active{
          background-color:#0052B4;
         }
         .seo-services .custom-dots li:nth-child(2).slick-active{
          background-color:#D9A8E5;
         }
          .seo-services .custom-dots li:nth-child(3).slick-active{
          background-color:#F79E1B;
         }
         .seo-services .custom-dots li:nth-child(4).slick-active{
          background-color:#FF4B55;
         }
        .custom-dots li button{
            position:absolute;
            width:100%;
            height:100%;
            top:0;
            left:0;
            opacity:0;
        }
        `}
      </style>
      <Slider ref={slider} {...settings} className={'seo-services w-full leading-[15px] pt-[45px]'}>
        <div className="px-[15px] pb-[20px]">
          <ProfessionalServicesCard
            cardClass="border-1 md:border-transparent hover:border-[#0052B4] border-[#0052B4] leading-[25px]"
            textClass="text-[#0052B4]"
            headerText="Professional Technical SEO"
          >
            When working on professional technical SEO, we check your website to identify and resolve common issues like slow-loading pages & problems
            that hinder search engines from properly indexing your site in search results. We focus on ensuring that your website has a user-friendly
            structure that caters to search engines and visitors. We also adjust how we describe your pages & organize content creation to match what
            people are searching for. By addressing these issues, as a professional SEO Services provider, we aim to improve your website visibility &
            make a user experience more enjoyable for visitors, which can lead to more people visiting, navigating & converting through your website.
          </ProfessionalServicesCard>
        </div>
        <div className="px-[15px] pb-[20px]">
          <ProfessionalServicesCard
            cardClass="md:mt-[50px] border-1 md:border-transparent hover:border-[#D9A8E5] border-[#D9A8E5]"
            textClass="text-[#D9A8E5]"
            headerText="Detailed On-Page SEO"
          >
            Through our Detailed On-page professional SEO services, we optimize your website functionality & content. We start with clear titles, and
            placement of keywords & ensure web pages comply with what customers would search for, so it will appear on the search results. We ensure
            your content is engaging & informative—optimizing even the smallest detail right from meta-descriptions to header tags. Our SEO Campaigns
            improve your site's layout & design, making it easy for visitors to find what they need with minimal hassle. The term "on-page"
            optimization encompasses all those activities that make a site not only interesting for its users but also strengthen its authority,
            improving its position in search.
          </ProfessionalServicesCard>
        </div>
        <div className="px-[15px] pb-[20px]">
          <ProfessionalServicesCard
            cardClass="border-1 md:border-transparent hover:border-[#F79E1B] border-[#F79E1B]"
            textClass="text-[#F79E1B]"
            headerText="Advanced Off-Page SEO"
          >
            Advanced Off-page SEO is activities we do to build up the reputation & visibility of your website beyond its pages. That is based on the
            construction of strong backlinks from trustworthy and related websites, considering that backlinking works to make search engines realize
            value and trust in your content. The process of your website optimization services includes strategic outreach & sharing content to earn
            mentions and links across the web, not to mention increasing your presence on social media platforms. We help increase your site authority
            & search engine rankings by managing your online reputation & growing your digital footprint, which in the process will help draw positive
            results.
          </ProfessionalServicesCard>
        </div>
        <div className="px-[15px] pb-[20px]">
          <ProfessionalServicesCard
            cardClass="md:mt-[50px] border-1 md:border-transparent hover:border-[#FF4B55] border-[#FF4B55]"
            textClass="text-[#FF4B55]"
            headerText="Accurate Local SEO"
          >
            Accurate Local SEO targets improve your visibility in local search results, essential for businesses with physical locations or regional
            services. We ensure your business is correctly listed on Google My Business and other directories to make sure local customers can find
            you easily. Your website content is also optimized with local-specific targeted keywords about your area, hence bettering relevance in the
            local search queries. We also ensure that through our Search Engine Optimization Services, we get reviews from your local clients, and
            that also greatly contributes to your credibility and ranking. We help your local business engage nearby customers, driving foot traffic
            and local inquiries to your location.
          </ProfessionalServicesCard>
        </div>
      </Slider>
    </>
  );
};

export default ProfessionalServicesSlider;
